import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const setAnalytics = (granted: boolean) => {
    const gtag = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
    if (typeof gtag === "function") gtag("consent", "update", { analytics_storage: granted ? "granted" : "denied" });
  };

  const accept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setAnalytics(true);
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setAnalytics(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-5 left-5 right-5 z-[9999] max-w-[520px] rounded-xl bg-[#111] p-5 text-white shadow-[0_8px_30px_rgba(0,0,0,0.25)]">
      <h3 className="mb-2.5 text-xl font-bold">We Value Your Privacy</h3>
      <p className="mb-4 text-sm leading-relaxed text-white/80">
        We use Google Analytics cookies to see which guides are useful. We do not use advertising, remarketing or social media tracking. Click "Decline" to turn analytics cookies off.
      </p>
      <div className="flex flex-wrap gap-2.5">
        <button
          onClick={accept}
          className="rounded-lg bg-primary px-4 py-2.5 text-sm font-bold text-white transition hover:brightness-110"
        >
          Accept
        </button>
        <button
          onClick={decline}
          className="rounded-lg bg-white/20 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-white/30"
        >
          Decline
        </button>
        <Link
          to="/privacy-policy"
          className="rounded-lg bg-white px-4 py-2.5 text-sm font-bold text-[#111] no-underline transition hover:bg-white/90"
        >
          View Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default CookieConsent;
